module.exports = __webpack_public_path__ + "img/Avatar-6.2c60ca64.gif";